var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import moment from 'moment';
import 'moment-timezone';
import { isDateBetween, isWeekend, SERVER_TIMEZONE } from '@ally/date-utils';
import { SERVER_DATE_FORMAT } from '../constants';
import { getFirstOrLastBusinessDay } from './getFirstOrLastBusinessDay';
import isFirstOrLastBusinessDayFrequency from './isFirstOrLastBusinessDayFrequency';
export function getDatePickerProps(_a) {
    var federalHolidays = _a.holidays.federal, minDate = _a.minDate, transferType = _a.transferType, maxAdvanceDuration = _a.maxAdvanceDuration, frequency = _a.frequency;
    function isHoliday(date) {
        // Check if date exists in holiday map
        return !!federalHolidays[date.format(SERVER_DATE_FORMAT)];
    }
    function isFirstLastBusinessDay(date) {
        if (!isFirstOrLastBusinessDayFrequency(frequency))
            return true;
        var businessDay = getFirstOrLastBusinessDay({
            federalHolidays: federalHolidays,
            date: date,
            frequency: frequency,
        });
        return businessDay.format('MM/DD/YYYY') === date.format('MM/DD/YYYY');
    }
    function getIsDayBlocked() {
        if (transferType === 'EXTERNAL') {
            return function (date) {
                return isWeekend(date) || isHoliday(date) || !isFirstLastBusinessDay(date);
            };
        }
        return function () { return false; };
    }
    function isOutsideRange(date) {
        var _a;
        var maxDate = (_a = moment.tz(SERVER_TIMEZONE)).add.apply(_a, __spreadArray([], __read(maxAdvanceDuration), false));
        return !isDateBetween(date, minDate, maxDate);
    }
    return {
        isDayBlocked: getIsDayBlocked(),
        isOutsideRange: isOutsideRange,
    };
}
export default getDatePickerProps;
//# sourceMappingURL=getDatePickerProps.js.map